/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { Backdrop, CircularProgress } from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { addMinutes, format } from "date-fns";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "universal-cookie";

// import Card from "@mui/material/Card";
// import Grid from "@mui/material/Grid";
// import Icon from "@mui/material/Icon";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";

import CloseIcon from "@mui/icons-material/Close";
// import Tooltip from "@mui/material/Tooltip";

// store actions
import {
  createDynamicColumn,
  getClientRejectedPurchaseOrders,
  getDynamicColumn,
  getSubModulesByRoleId,
  getVendorRejectedPurchaseOrders,
} from "../../../store";

const cookies = new Cookies();

const RejectedPO = ({
  // actions
  getSubModulesByRoleId,
  getClientRejectedPurchaseOrders,
  getVendorRejectedPurchaseOrders,
  // reducers
  getSubModulesByRoleIdReducer,
  clientRejectedReducer,
  vendorRejectedReducer,
  getDynamicColumnReducer,
  getDynamicColumn,
  createDynamicColumn,
}) => {
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const loginDetails = cookies.get("loginDetailsForWMS");

  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  const jwtToken = loginDetails?.jwt;
  const roleId = loginDetails?.data?.roleId;
  const userId = loginDetails?.data?.userId;
  const roleName = loginDetails?.data?.roleName;
  const email = loginDetails?.data?.email;

  const vendorRolePattern = /vendor/i;
  const isVendor = vendorRolePattern.test(roleName);

  useEffect(() => {
    if (roleId && jwtToken) getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId, jwtToken, getSubModulesByRoleId]);

  const [modulesData, setModulesData] = useState([]);
  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData?.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let purchaseOrderModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "0981180a-b90f-4288-8dab-e85776e28e16",
  );

  let viewAccess = purchaseOrderModule
    ? purchaseOrderModule.actionId.includes(
        "855be5f7-d175-488e-8231-1446eb39e0fa",
      )
    : null;
  const subModuleId = "0981180a-b90f-4288-8dab-e85776e28e16";

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [loading, setLoading] = useState(true);

  // // role-based fetch
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (!jwtToken) return;
  //     if (
  //       roleName === "admin" ||
  //       roleName === "Admin" ||
  //       roleName === "spAdmin" ||
  //       roleName === "spadmin"
  //     ) {
  //       getClientRejectedPurchaseOrders?.(
  //         pageNo,
  //         rowsPerPage,
  //         searchObject,
  //         jwtToken
  //       );
  //     } else {
  //       getVendorRejectedPurchaseOrders?.(
  //         email,
  //         pageNo,
  //         rowsPerPage,
  //         searchObject,
  //         jwtToken
  //       );
  //     }
  //   }, 500);
  //   return () => clearTimeout(timer);
  // }, [
  //   roleName,
  //   pageNo,
  //   rowsPerPage,
  //   searchObject,
  //   jwtToken,
  //   getClientRejectedPurchaseOrders,
  //   getVendorRejectedPurchaseOrders,
  // ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!jwtToken) return;

      isVendor
        ? getVendorRejectedPurchaseOrders?.(
            email,
            pageNo,
            rowsPerPage,
            searchObject,
            jwtToken,
          )
        : getClientRejectedPurchaseOrders?.(
            pageNo,
            rowsPerPage,
            searchObject,
            jwtToken,
          );
    }, 500);

    return () => clearTimeout(timer);
  }, [
    isVendor,
    pageNo,
    rowsPerPage,
    searchObject,
    jwtToken,
    getClientRejectedPurchaseOrders,
    getVendorRejectedPurchaseOrders,
  ]);

  const [state, setState] = useState({
    columns: [
      { Header: "PO No.", accessor: "purchaseOrderNumber" },
      { Header: "PO LineNo.", accessor: "purchaseOrderLineNumber" },
      { Header: "Vendor Code", accessor: "vendorCode" },
      { Header: "Item code", accessor: "itemCode" },
      // { Header: "Item Description", accessor: "itemDescription" },
      { Header: "Po Date", accessor: "date" },
      { Header: "Qty", accessor: "qty" },
      { Header: "Unloading Point", accessor: "unloadingPoint" },
      { Header: "Delivery Plant", accessor: "deliveryPlant" },
      // { Header: "Status", accessor: "status" },
    ],
    rows: [],
  });

  useEffect(() => {
    const slice = isVendor ? vendorRejectedReducer : clientRejectedReducer;

    if (!slice) {
      setLoading(false);
      setPaginationObj({});
      setState((prev) => ({ ...prev, rows: [] }));
      return;
    }

    const envelope = slice?.purchaseOrders || {};
    const data = envelope?.data || [];
    setPaginationObj(envelope?.pagination || {});
    setLoading(!!slice?.loading);

    const mapped = data.map((purchase) => {
      const dt = purchase?.date ? new Date(purchase.date) : null;
      return {
        privateKey: purchase?.purchaseOrderId,
        purchaseOrderNumber: purchase?.purchaseOrderNumber,
        purchaseOrderLineNumber: purchase?.purchaseOrderLineNumber,
        vendorCode: purchase?.vendorCode,
        purchaseOrderId: purchase?.purchaseOrderId,
        itemCode: purchase?.itemCode,
        itemDescription: purchase?.itemDescription,
        isReleased: purchase?.isReleased,
        date: dt
          ? format(addMinutes(dt, dt.getTimezoneOffset()), "do MMMM yyyy")
          : "",
        qty: purchase?.qty,
        unloadingPoint:
          purchase?.unloadingPoint == null ||
          purchase?.unloadingPoint === "undefined"
            ? "NA"
            : purchase?.unloadingPoint,
        deliveryPlant:
          purchase?.deliveryPlant == null ||
          purchase?.deliveryPlant === "undefined"
            ? "NA"
            : purchase?.deliveryPlant,
        status: "Rejected",
      };
    });
    setState((prev) => ({ ...prev, rows: mapped }));
  }, [clientRejectedReducer, vendorRejectedReducer, isVendor]);
  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };
  const importRowsPerPage = (pageSize) => setRowsPerPage(pageSize);
  const importSearch = (globalFilter) =>
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");

  const { columns, rows } = state;

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);

    if (res.status) {
      setIsSuccessColumnReorder(true);

      getDynamicColumn(userId, subModuleId, jwtToken);

      // 🔁 replace getAcceptedPoClient with conditional logic
      if (!jwtToken) return;

      isVendor
        ? getVendorRejectedPurchaseOrders?.(
            email,
            pageNo,
            rowsPerPage,
            searchObject,
            jwtToken,
          )
        : getClientRejectedPurchaseOrders?.(
            pageNo,
            rowsPerPage,
            searchObject,
            jwtToken,
          );

      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
      }, 2250);
    } else {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  const [disableButton, setDisableButton] = useState(false);

  return (
    <div>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mt={0}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted
                  tableSearch
                  showTotalEntries
                  noEndBorder
                  loading={loading}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  serverSidePagination
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  options={{ draggable: false }}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                  disableButton={disableButton}
                />
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  clientRejectedReducer: state.getClientRejectedPurchaseOrdersReducer,
  vendorRejectedReducer: state.getVendorRejectedPurchaseOrdersReducer,

  getDynamicColumnReducer: state.getDynamicColumnReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getClientRejectedPurchaseOrders: (
    pageNo,
    rowsPerPage,
    searchObject,
    jwtToken,
  ) =>
    dispatch(
      getClientRejectedPurchaseOrders(
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      ),
    ),
  getVendorRejectedPurchaseOrders: (
    pageNo,
    rowsPerPage,
    searchObject,
    jwtToken,
  ) =>
    dispatch(
      getVendorRejectedPurchaseOrders(
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      ),
    ),
  getDynamicColumn: (userId, subModuleId, jwtToken) =>
    dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
  createDynamicColumn: (payload, jwtToken) =>
    dispatch(createDynamicColumn(payload, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RejectedPO);
